import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';


import MisCertificados from './containers/mis_certificados';
import Certificado from './containers/certificado';

export const develop = window.location.hostname==="localhost" || window.location.hostname.includes("192.168.");

if (!develop && window.location.protocol !== 'https:') {
  if (develop===true) console.log("redireccionado a https");
  else window.location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
}

/*const Empty = (props) => {
  return (
      <span/>
  );
};*/

ReactDOM.render(
  <BrowserRouter>
      <Switch>
        <Route path="/certificado/:idcertificado/:ci" component={Certificado} />
        <Route path="/mis-certificados/" component={MisCertificados} />
        <Route path="/" component={MisCertificados} />
      </Switch>
  </BrowserRouter>
  , document.querySelector('#APP'));



// WEBPACK FOOTER //
// ./src/index.js